import React from 'react';
import { Col, Container } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import Forms from './components/Forms';

const ViagemCadastro = () => {
  return (
    <Container fluid>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[
            { name: 'Início', path: '/' },
            { name: 'Viagens', path: '/pages/viagens' },
            { name: 'Criar/Editar' }
          ]}
        />
      </Col>
      <Forms />
    </Container>
  );
};

export default ViagemCadastro;
